export function getView(phones, emails) {
  return phones.length === 0 && emails.length === 0
}
